import React from 'react';
import { Container } from '../../atoms';
import { SectionHeader } from '../../molecules';
import DepartmentsSectionDepartment from './DepartmentsSectionDepartment';
export default function DepartmentsSection(param) {
    var title = param.title, subtitle = param.subtitle, departments = param.departments, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(Container, {
        name: DepartmentsSection.name,
        className: "mb-6 md:mb-8",
        containerClassName: "max-w-md"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "text-center"
    })), /*#__PURE__*/ React.createElement(Container, {
        name: DepartmentsSection.name,
        containerClassName: "max-w-lg"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-9 md:gap-10"
    }, departments === null || departments === void 0 ? void 0 : departments.map(function(dep) {
        return /*#__PURE__*/ React.createElement(DepartmentsSectionDepartment, {
            key: dep.title,
            department: dep
        });
    }))));
}

//# sourceMappingURL=DepartmentsSection.js.map